import { Box, useMediaQuery, useTheme } from '@mui/material';

interface Props {
    lawFirmId: string | undefined;
}

export default function LawFirmLogo({ lawFirmId }: Props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            {lawFirmId && (
                <img
                    alt="Law firm logo"
                    style={{
                        height: isMobile ? '80px' : '200px',
                        width: isMobile ? '80px' : '200px',
                        borderRadius: '4px',
                    }}
                    src={`${import.meta.env.VITE_APP_API_URL}/api/v1/files/${lawFirmId}/logo`}
                />
            )}
        </Box>
    );
}
